import { useContext, useEffect, useState } from "react";
import {
  createADOIssueApiCall,
  getADOAvailableFields,
  getAllAdoProjects,
  updateADOIssueToADO,
} from "../../../../services/webServices";
import JiraProjectsComponentPage from "../../../common-components/JiraProjectsComponentPage";
import { LoadingModalContext, MessagePopupContext } from "../../ServicePage";

const ADOExportPage = ({
  taskType,
  issueType,
  setADOPageOpen,
  exportData,
  almConfig,
}) => {
  const [projectsList, setProjectsList] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [importLoading, setImportLoading] = useState(null);

  const [messagePopUpOpen, setMessagePopupOpen] = useState(false);

  const { setLoadingState } = useContext(LoadingModalContext);
  const { setMessage, setMessagePopup } = useContext(MessagePopupContext);

  useEffect(() => {
    const fetchProjects = async () => {
      Promise.resolve().then(() => setImportLoading("Projects")); // Next microtask
      try {
        const getProjectsFromJiraAPI = await getAllAdoProjects();
        setProjectsList(getProjectsFromJiraAPI.data);
      } catch (error) {
        console.error("Error fetching projects:", error);
      } finally {
        setImportLoading(null);
      }
    };
    fetchProjects();
  }, []);

  useEffect(() => {
    if(selectedProject) {
      handleExport();
    }
  }, [selectedProject]);

  const handleExport = async () => {
    if (!selectedProject) {
      console.error("No project selected for export.");
      return;
    }

    setLoadingState({
      open: true,
      message: `Exporting ${issueType}`,
      progress: null,
    });

    try {
      const adoIssueType = getADOIssueType(issueType);

      const payload = {
        projectName: selectedProject.name,
        issueType: adoIssueType, 
        issueData: exportData,
      };

      const isUpdate =
        !!almConfig &&
        almConfig.toolName === "Azure" &&
        almConfig.issueType === issueType;

      if (isUpdate) {
        await updateADOIssueToADO(payload);
        setMessagePopup(true);
        setMessage(`${issueType} updated successfully.`);
      } else {
        await createADOIssueApiCall(payload);
        setMessagePopup(true);
        setMessage(`${issueType} exported successfully.`);
      }
      setADOPageOpen(false);
    } catch (error) {
      console.error("Error exporting data:", error);
      setMessagePopup(true);
      setMessage(`Error exporting ${issueType}. Please try again.`);
    } finally {
      setLoadingState({ open: false, message: "", progress: null });
      setADOPageOpen(false);
    }
  };

  const getADOIssueType = (issueType) => {
    switch (issueType) {
      case "Bugs":
      case "Bug":
        return "Bug";
      case "User Stories":
      case "Story":
        return "Story";
      case "Test Cases":
        return "Test Case";
      case "Epics":
        return "Epic";
      case "Features":
        return "Feature";
      default:
        return "Story"; 
    }
  };

  return (
    <div>
      {!selectedProject && (
        <JiraProjectsComponentPage
          taskType={taskType}
          issueType={issueType}
          projectsLoading={importLoading === "Projects"}
          setOpenProjectPage={setADOPageOpen}
          selectedProject={selectedProject}
          setSelectedProject={setSelectedProject}
          projectsList={projectsList}
        />
      )}
    </div>
  );
};

export default ADOExportPage;
